import { AxiosError } from "axios";
import { UseFormSetError } from "react-hook-form";
import { ApiError } from "types/ApiError";

export const apiErrorHandler = <TFormValues>(
  error: AxiosError<ApiError<TFormValues>>,
  setError?: UseFormSetError<TFormValues>
) => {
  if (setError && error.response && error.response.status === 400) {
    error.response?.data.forEach((e) => {
      setError(e.name, { type: "api", message: e.message });
    });
  }
};
